import { useCallback as r } from "react";
import { checkIsMapLoaded as a } from "./index.es245.js";
import { usePLMapboxStoreV2 as p } from "./index.es6.js";
const u = () => r(({ mapId: e }) => {
  var o, t;
  if (!a(e)) {
    console.warn(`MapId "${e}" is not loaded yet. 
                            Make sure the PLMapbox component is properly mounted before getting the basemap.`);
    return;
  }
  return (t = (o = p.getState().maps) == null ? void 0 : o[e]) == null ? void 0 : t.basemap;
}, []);
export {
  u as useGetBasemap
};
//# sourceMappingURL=index.es196.js.map
